import React, { useState, useEffect, useMemo } from "react";
import "./Home.css";
import ECommerce from "../../images/E-Commerce.jpg";
import Womensafety from "../../images/Womens_safety.jpg";
import SGS from "../../images/SGS.jpg";
import AMS from "../../images/AMS.jpg";
import HRMS from "../../images/HRMS.jpg";
import digitalMarketing from "../../images/digitalMarketing.avif";
import softwareDevelopment from "../../images/software development.jpg";
import mobileDevelopment from "../../images/mobileDevelopment.webp";
import softwareImg from "../../images/softwareImg.png";
import aiImg from "../../images/aiImg.png";
import uiuxImg from "../../images/uiuxImg.png";
import mobileImg from "../../images/mobileImg.webp";
import lowcodeImg from "../../images/lowcodeImg.png";
import marketingImg from "../../images/marketingImg.png";
import cloudImg from "../../images/cloudImg.png";
import supportImg from "../../images/supportImg.png";
import Matchmaking from "../../images/jusstmingle-logo.png";
import jusstmingleAdmin from "../../images/jm-logo.png";
import iCareImage from "../../images/iCareImage.png";
// import Safiyaa from "../../images/Safiyaa.png"
import rakshen from "../../images/Rakshak.png"

import { Link } from "react-router-dom";
import { FaReact, FaNode, FaDocker, FaAws, FaGithub, FaAngular, FaJava, FaHtml5, FaCss3, FaJs } from 'react-icons/fa'; // React Icons
import { SiPostgresql, SiExpress, SiMongodb, SiFigma } from 'react-icons/si'; // Additional tech icons



// Hero content
const image = {
  // imgURL: school1,
  imgAlt: "Software Solutions Hero",
  text: "Next-Gen IT Solutions for Future-Ready Businesses",
  subText:
    "We design, build, and scale custom ERP, AI, mobile and cloud solutions that unlock real business growth.",
};

// Carousel data
const carouselData = [
  { description: "E-Commerce", image: ECommerce },
  { description: "Women's Safety", image: Womensafety },
  { description: "Security Guard Management", image: SGS },
  { description: "Attendance Management System", image: AMS },
  { description: "Human Resorces Management System", image: HRMS },
  { description: "Digital Marketing", image: digitalMarketing },
  { description: "Software Development", image: softwareDevelopment },
  { description: "Mobile App Development", image: mobileDevelopment },
  { description: "JusstMingle App", image: jusstmingleAdmin },
  { description: "i Care Image", image: iCareImage },
  { description: "rakshen", image: rakshen },  

        
  // { description: "Service Sector Agility", image: erpThree },
  // { description: "Manufacturing Efficiency Boost", image: erpFour },
];

// Group images into slides
// const groupImages = (data, itemsPerSlide) => {
//   const grouped = [];
//   for (let i = 0; i < data.length; i += itemsPerSlide) {
//     grouped.push(data.slice(i, i + itemsPerSlide));
//   }
//   return grouped;
// };
// Helper function to group images into slides (responsive logic)
const groupImages = (data, itemsPerSlide) => {
  const grouped = [];
  for (let i = 0; i < data.length; i += itemsPerSlide) {
    grouped.push(data.slice(i, i + itemsPerSlide));
  }
  return grouped;
};

// Helper to calculate how many items per slide based on screen size
const getItemsPerSlide = () => {
  const width = window.innerWidth;
  if (width < 600) return 1;
  if (width < 900) return 2;
  return 4;
};
// 🔹 New: core “Our Services” cards (like screenshot)
const coreServices = [
  {
    id: "software-dev",
    title: "Software Development",
    intro:
      "We have 3+ years experience in the market – we develop the best web & mobile products for our customers.",
    points: [
      "Custom Software Development",
      "Website Designing & Development",
      "Mobile Application",
      "E-commerce Solutions",
      "ERP Development",
      "HRMS Development",
    ],
    link: "/SoftwareDevelopment", // 👉 change to your actual route if needed
  },
  {
    id: "digital-marketing",
    title: "Digital Marketing",
    intro:
      "Our next-generation marketers convert your website into a powerful business growth channel.",
    points: [
      "Social Media Marketing",
      "Search Engine Marketing",
      "Search Engine Optimization (SEO)",
      "Website & App Promotion",
      "Video Marketing",
      "Bulk SMS / Campaign Marketing",
    ],
    link: "/DigitalMarketing",
  },
  {
    id: "iot-services",
    title: "IoT Services",
    intro:
      "Connect devices, automate workflows, and build intelligent IoT ecosystems for your business.",
    points: [
      "Smart Devices Integration",
      "Remote Monitoring & Control",
      "IoT Automation Solutions",
      "Sensor-based Data Collection",
      "Predictive Maintenance",
      "Industrial IoT (IIoT)",
    ],
    link: "/IoTServices",
  },
  {
    id: "ai-integration",
    title: "AI Integration",
    intro:
      "Enhance your products with AI-powered automation, insights, and smart decision-making.",
    points: [
      "AI Chatbots & Virtual Assistants",
      "Machine Learning Models",
      "Predictive Analytics",
      "Process Automation",
      "Natural Language Processing (NLP)",
      "AI-powered Recommendations",
    ],
    link: "/AIIntegration",
  },
  {
    id: "cloud-services",
    title: "Cloud Services",
    intro:
      "Scalable, secure and cost-optimized cloud solutions to transform your digital infrastructure.",
    points: [
      "Cloud Migration",
      "Serverless Architecture",
      "DevOps & CI/CD Setup",
      "Cloud Storage & Backups",
      "Cloud Security & Governance",
      "AWS / Azure / GCP Deployments",
    ],
    link: "/CloudServices",
  },
  {
    id: "mobile-app-development",
    title: "Mobile Application Development",
    intro:
      "We build fast, secure, and scalable mobile applications tailored to your business needs.",
    points: [
      "Android & iOS App Development",
      "Cross-Platform Apps (React Native / Flutter)",
      "UI/UX Design for Mobile Experiences",
      "API & Backend Integration",
      "App Deployment & Play Store Support",
      "Maintenance & Feature Enhancements",
    ],
    link: "/SoftwareDevelopment",
  },
];

const INDUSTRIES = [
  {
    id: "real-estate",
    title: "Real Estate",
    desc: "Unlock the potential of construction with digital-era software solutions for streamlined project management and increased efficiency.",
  },
  {
    id: "healthcare",
    title: "Healthcare & Hospitality",
    desc: "Revolutionize patient care and guest experience with user-friendly healthcare and hospitality software.",
  },
  {
    id: "retail",
    title: "Retail & E-Commerce",
    desc: "Modern retail & e-commerce solutions designed to create engaging, personalized shopping experiences.",
  },
  {
    id: "education",
    title: "Education & Sports",
    desc: "Enhance learning and performance with innovative educational and sports management platforms.",
  },
  {
    id: "travel",
    title: "Travels & Import/Export",
    desc: "Improve travel and logistics operations with practical, automation-first software solutions.",
  },
  {
    id: "banking",
    title: "Banking & Finance",
    desc: "Deliver secure, multi-stage testing and auditing of your financial software systems.",
  },
  {
    id: "auto",
    title: "Auto & Manufacturing",
    desc: "We create innovative web and mobile app solutions to meet the demands of the booming automobile and manufacturing industry.",
    cta: "view more",
  },
  {
    id: "food",
    title: "Food & Restaurant",
    desc: "Revolutionize your food and restaurant operations with user-friendly and feature-rich software to streamline processes and delight customers.",
    cta: "view more",
  },
  {
    id: "government",
    title: "Government",
    desc: "Partner with government and public sector organizations to deliver reliable, secure IT systems that support digital transformation.",
    cta: "view more",
  },
];

export default function Home() {
   const [currentIndex, setCurrentIndex] = useState(0);
  const [itemsPerSlide, setItemsPerSlide] = useState(getItemsPerSlide());

  // Recalculate the items per slide on window resize
  useEffect(() => {
    const handleResize = () => {
      setItemsPerSlide(getItemsPerSlide());
    };
    handleResize();
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const groupedCarouselData = useMemo(
    () => groupImages(carouselData, itemsPerSlide),
    [itemsPerSlide]
  );

  const totalSlides = groupedCarouselData.length;

  // Auto-rotate carousel
  useEffect(() => {
    if (totalSlides <= 1) return;

    const interval = setInterval(() => {
      setCurrentIndex((prevIndex) => (prevIndex === totalSlides - 1 ? 0 : prevIndex + 1));
    }, 5000); // Auto-rotate every 5 seconds

    return () => clearInterval(interval);
  }, [totalSlides]);

  const goToNext = () => {
    setCurrentIndex((prevIndex) => (prevIndex === totalSlides - 1 ? 0 : prevIndex + 1));
  };

  const goToPrevious = () => {
    setCurrentIndex((prevIndex) => (prevIndex === 0 ? totalSlides - 1 : prevIndex - 1));
  };


  const ServiceCard = ({ icon, title, description }) => (
    <div className="service-card">
      <div className="service-icon">{icon}</div>
      <h3 className="service-title">{title}</h3>
      <p className="service-description">{description}</p>
    </div>
  );

  // 🔹 Software Development Process steps
  const processSteps = [
    {
      step: "01",
      title: "Discovery & Consulting",
      text: "We understand your business, workflows, and tech challenges through workshops and deep-dive sessions.",
      bullets: ["Requirement analysis", "Process mapping", "Tech consulting"],
    },
    {
      step: "02",
      title: "Solution Design",
      text: "Our team designs the architecture, data flow, and UX so your product is scalable, secure, and easy to use.",
      bullets: ["System architecture", "Database schema", "User journey & UX"],
    },
    {
      step: "03",
      title: "Agile Development",
      text: "We build in iterative sprints with regular demos so you can see progress and give feedback in real time.",
      bullets: [
        "Sprint-based delivery",
        "Clean, tested code",
        "Continuous integration",
      ],
    },
    {
      step: "04",
      title: "Launch & Ongoing Support",
      text: "We help you go live smoothly and stay with you for enhancements, monitoring, and long-term maintenance.",
      bullets: [
        "Deployment & training",
        "Performance monitoring",
        "Continuous improvement",
      ],
    },
  ];

  return (
    <div className="home-container">
      {/* HERO SECTION */}
      <section className="hero-section">
        <div className="hero-orb hero-orb-left" />
        <div className="hero-orb hero-orb-right" />

        <div className="hero-inner">
          <div className="hero-content">
            <div className="hero-pill-row">
              <span className="hero-pill">Software Development Company</span>
              <span className="hero-pill-outline">
                ERP • AI • Mobile • Cloud
              </span>
            </div>

            <h1 className="hero-title">{image.text}</h1>

            <p className="hero-subtitle">{image.subText}</p>

            <ul className="hero-points">
              <li>✔ Tailor-made ERP solutions for complex operations</li>
              <li>✔ AI &amp; analytics that turn data into decisions</li>
              <li>✔ Secure, scalable cloud architecture for growth</li>
            </ul>

            {/* <div className="hero-cta-row">
              <button className="cta-button">Book a Free Consultation</button>
              <button className="secondary-cta-button">
                View Case Studies
              </button>
            </div> */}
            <div className="hero-cta-row">
  <Link to="/contact">
    <button className="cta-button">Book a Free Consultation</button>
  </Link>

  <Link to="/SoftwareDevelopment">
    <button className="secondary-cta-button">
      View Case Studies
    </button>
  </Link>
</div>

            <div className="hero-stats">
              <div className="hero-stat">
                <span className="hero-stat-number">55+</span>
                <span className="hero-stat-label">Projects Delivered</span>
              </div>
              <div className="hero-stat">
                <span className="hero-stat-number">20+</span>
                <span className="hero-stat-label">Industries Served</span>
              </div>
              <div className="hero-stat">
                <span className="hero-stat-number">100%</span>
                <span className="hero-stat-label">Client Satisfaction</span>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* CAROUSEL SECTION */}
      <section className="carousel">
      <h2>Success Stories with ERP Next</h2>
      <p className="about-subtext partner-subtext">
        Discover how businesses transformed operations and scaled faster with our tailored ERP implementations.
      </p>

      <div className="carousel-container">
        <button className="prev-btn" onClick={goToPrevious}>
          &#8249;
        </button>

        <div className="carousel-images">
          <div
            className="carousel-images-wrapper"
            style={{
              transform: `translateX(-${currentIndex * 100}%)`,
              transition: "transform 1s ease-in-out", // Smooth transition
            }}
          >
            {groupedCarouselData.map((slide, slideIndex) => (
              <div key={slideIndex} className="carousel-slide">
                {slide.map((item, index) => (
                  <div key={index} className="carousel-image">
                    <div className="carousel-image-shell">
                      <img
                        src={item.image}
                        alt={item.description}
                        className="carousel-image-img"
                      />
                    </div>
                    <p>{item.description}</p>
                  </div>
                ))}
              </div>
            ))}
          </div>
        </div>

        <button className="next-btn" onClick={goToNext}>
          &#8250;
        </button>
      </div>

      <div className="carousel-indicators">
        {groupedCarouselData.map((_, index) => (
          <span
            key={index}
            className={index === currentIndex ? "active" : ""}
            onClick={() => setCurrentIndex(index)}
          ></span>
        ))}
      </div>
    </section>

      {/* 🔹 NEW: CORE SERVICES CARDS (like screenshot) */}
      <section className="core-services-section">
        <h2 className="core-services-heading">Our Services</h2>
        <p className="about-subtext partner-subtext">
          At our company, we pride ourselves on thinking big and offering a
          diverse range of services across major technology platforms.
        </p>

        <div className="core-services-grid">
          {coreServices.map((svc) => (
            <div key={svc.id} className="core-service-card">
              <div className="core-service-top-strip" />
              <div className="core-service-inner">
                <h3 className="core-service-title">{svc.title}</h3>
                <p className="core-service-intro">{svc.intro}</p>

                <div className="core-service-divider" />

                <ul className="core-service-list">
                  {svc.points.map((pt, idx) => (
                    <li key={idx}>{pt}</li>
                  ))}
                </ul>

                <a href={svc.link} className="core-service-btn">
                  View More <span className="core-service-btn-arrow">➜</span>
                </a>
              </div>
            </div>
          ))}
        </div>
      </section>

      {/* SERVICES GRID SECTION */}
      <section className="services-container">
        <h2>Our Services &amp; Solutions</h2>
        <p className="about-subtext partner-subtext">
          We design, build, and scale digital products that solve real business
          problems.
        </p>

        <div className="service-cards">
          <ServiceCard
            icon={
              <img
                src={softwareImg}
                alt="Custom Software Development"
                className="service-img"
              />
            }
            title="Custom Software Development"
            description="End-to-end development of web and desktop applications tailored to your workflows."
          />

          <ServiceCard
            icon={
              <img
                src={aiImg}
                alt="AI & ML Solutions"
                className="service-img"
              />
            }
            title="AI & ML Solutions"
            description="Turn your data into intelligent decisions with AI-powered automation and analytics."
          />

          <ServiceCard
            icon={
              <img src={uiuxImg} alt="UI/UX Design" className="service-img" />
            }
            title="UI/UX Design"
            description="Human-centered design for delightful, intuitive, and conversion-driven experiences."
          />

          <ServiceCard
            icon={
              <img
                src={mobileImg}
                alt="Mobile App Development"
                className="service-img"
              />
            }
            title="Mobile App Development"
            description="High-performance Android & cross-platform apps."
          />
        </div>

        <div className="service-cards">
          <ServiceCard
            icon={
              <img
                src={lowcodeImg}
                alt="Low-Code Development"
                className="service-img"
              />
            }
            title="No-Code / Low-Code"
            description="Quickly prototype & launch solutions using low-code platforms."
          />

          <ServiceCard
            icon={
              <img
                src={marketingImg}
                alt="Digital Marketing"
                className="service-img"
              />
            }
            title="Digital Marketing"
            description="We help your brand get discovered, trusted & chosen."
          />

          <ServiceCard
            icon={
              <img
                src={cloudImg}
                alt="Cloud Solutions"
                className="service-img"
              />
            }
            title="Cloud Solutions"
            description="Cloud-native architecture, DevOps & scalable infrastructure."
          />

          <ServiceCard
            icon={
              <img
                src={supportImg}
                alt="Support & Maintenance"
                className="service-img"
              />
            }
            title="Maintenance & Support"
            description="Continuous monitoring, updates & reliability improvement."
          />
        </div>
      </section>

      {/* PROCESS SECTION */}
      {/* <section className="process-section">
        <div className="process-tech-strip">
          <span className="process-tech-label">Tech we work with:</span>
          <div className="process-tech-tags">
            <span className="process-tech-tag">React</span>
            <span className="process-tech-tag">React Native</span>
            <span className="process-tech-tag">Node.js</span>
            <span className="process-tech-tag">Express</span>
            <span className="process-tech-tag">PostgreSQL</span>
            <span className="process-tech-tag">MongoDB</span>
            <span className="process-tech-tag">REST APIs</span>
            <span className="process-tech-tag">AWS / Cloud</span>
            <span className="process-tech-tag">Docker &amp; CI/CD</span>
            <span className="process-tech-tag">Figma &amp; UI Systems</span>
          </div>
        </div>
      </section> */}
      <section className="process-section">
        {/* <h2>
        <span className="process-tech-label">Tech we work with:</span>
        </h2> */}
         <h2>
        <h2 className="process-tech-label">Tech we work with:</h2>
        </h2>
      <div className="process-tech-strip">
        <div className="process-tech-tags">
          <span className="process-tech-tag">
            <FaReact /> React.js
          </span>
          <span className="process-tech-tag">
            <FaReact /> React Native
          </span>
          <span className="process-tech-tag">
            <FaNode /> Node.js
          </span>
          <span className="process-tech-tag">
            <SiExpress /> Express
          </span>
          <span className="process-tech-tag">
            <SiPostgresql /> PostgreSQL
          </span>
          <span className="process-tech-tag">
            <SiMongodb /> MongoDB
          </span>
          <span className="process-tech-tag">
            <FaGithub /> REST APIs
          </span>
          <span className="process-tech-tag">
            <FaAws /> AWS / Cloud
          </span>
          <span className="process-tech-tag">
            <FaDocker /> Docker & CI/CD
          </span>
          <span className="process-tech-tag">
            <SiFigma /> Figma & UI Systems
          </span>
          <span className="process-tech-tag">
            <FaAngular /> Angular
          </span>
          <span className="process-tech-tag">
            <FaJava /> Java
          </span>
          <span className="process-tech-tag">
            <FaJs /> JavaScript
          </span>
          <span className="process-tech-tag">
            <FaHtml5 /> HTML
          </span>
        </div>
      </div>
    </section>

      <section className="industries-section">
        <div className="industries-inner">
          <div className="process-header">
            <h2>Industries We Serve</h2>
            <p className="about-subtext partner-subtext">
              As a leading custom software development company, we strive to
              deliver exceptional and scalable software solutions tailored to
              our client&apos;s unique needs.
            </p>
          </div>

          <div className="industries-grid">
            {INDUSTRIES.map((item) => (
              <article key={item.id} className="industry-card">
                <div className="industry-card-top">
                  <span className="industry-icon" aria-hidden="true">
                    {item.id === "real-estate" && "🏗️"}
                    {item.id === "healthcare" && "🏥"}
                    {item.id === "retail" && "🛍️"}
                    {item.id === "education" && "🎓"}
                    {item.id === "travel" && "✈️"}
                    {item.id === "banking" && "💳"}
                    {item.id === "auto" && "💡"}
                    {item.id === "food" && "☁️"}
                    {item.id === "government" && "📄"}
                  </span>
                </div>

                <div className="industry-card-body">
                  <h3 className="industry-name">{item.title}</h3>
                  <p className="industry-desc">{item.desc}</p>
                </div>
              </article>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
}
